module.exports = __webpack_public_path__ + "img/H1.8cc48527.png";